import { baseApi } from './baseApi';
import { API_ENDPOINTS } from '@nimbazaar/constants';

interface ApiResponse<T> {
  success: boolean;
  message?: string;
  data: T;
}

export const newsletterApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    subscribeNewsletter: builder.mutation<ApiResponse<unknown>, { email: string }>({
      query: (body) => ({
        url: API_ENDPOINTS.NEWSLETTER.SUBSCRIBE,
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const { useSubscribeNewsletterMutation } = newsletterApi;
